import {
  HttpTransportType,
  type HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";

import { removeTokenPrefix } from "~/utils/auth";

export default defineNuxtPlugin<{
  _connection: HubConnection | undefined;
}>({
  name: "signalR",
  parallel: true,
  dependsOn: ["amplify"],
  setup: () => {
    const runtimeConfig = useRuntimeConfig();
    const websocketUrl = runtimeConfig.public.websocketUrl;

    if (import.meta.server || !websocketUrl) {
      return {
        provide: {
          _connection: undefined,
        },
      };
    }

    const auth = useAuth();
    const getAccessToken = async (): Promise<string | undefined> => {
      const token = await auth.getToken();

      if (typeof token === "boolean") return undefined;

      if (token?.includes("Bearer")) {
        return removeTokenPrefix(token, "Bearer");
      }

      return token;
    };

    const platformStore = usePlatformStore();
    const platformId = platformStore.tryGetPlatformConfiguration?.platformId;

    const _connection = new HubConnectionBuilder()
      .withUrl(`${websocketUrl}/hubs/updates?platform_id=${platformId}`, {
        transport: HttpTransportType.WebSockets,
        accessTokenFactory: async () => (await getAccessToken()) ?? "",
      })
      .configureLogging(LogLevel.Error)
      .withAutomaticReconnect()
      .build();

    return {
      provide: {
        _connection,
      },
    };
  },
});
